import React, { useState, useEffect } from "react";
import ModulePreviewData from "./ModulePreviewData";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";
import "./ModuleView.scss";
import checkMark from "../../../images/CheckmarkGreen.svg";
import checkMarkExpired from "../../../images/checkmark-nonfilled.svg";
import NotApprovedImage from '../../../images/not-approved-image.svg';

import Tooltip from "@material-ui/core/Tooltip";
import Dialog from "@material-ui/core/Dialog";

// const modulePreviewData={
//   "moduleId": "df1f56da-e2d8-468e-bd34-f7216a3f9202",
//   "moduleName": "Test Duplicates",
//   "moduleDamId": "V3Q000000017002",
//   "moduleDamName": "CM-000305",
//   "nextUniqueModuleCode": "BI_Module_063",
//   "source": "PromoMats",
//   "productName": "Biktarvy",
//   "productDamId": "00P000000000H01",
//   "countryName": "Spain",
//   "countryDamId": "spain",
//   "topicDamId": "V6G000000001006",
//   "topicName": "Patient Services",
//   "subtopicDamId": "V6F000000001025",
//   "subtopicName": "Resources to More Information",
//   "languageDamId": "V5B000000001008",
//   "languageName": "English",
//   "therapeuticAreaDamId": "V1L000000001010",
//   "therapeuticAreaName": "Cell Therapy",
//   "audienceDamId": "V3T000000001003",
//   "audienceName": "Professional",
//   "usageGuidelines": "Test updated ",
//   "brandStyleGuidelines": "",
//   "communicationObjectives": "Test Duplicates",
//   "mlrStatus": "Available for Use",
//   "createdByName": "Muniraj G",
//   "businessRulePublished": null,
//   "moduleDamUrl": "https://sb-gilead-poc-global-promomats.veevavault.com/ui/#object/content_module__v/V3Q000000017002",
//   "componentUrl": "https://d2ssk39mx0njby.cloudfront.net/components/df1f56da-e2d8-468e-bd34-f7216a3f9202/02319624-2b27-4f4a-ba4b-51fef3f99c4f/4973_1_0.png",
//   "componentThumbnailUrl": "https://d2ssk39mx0njby.cloudfront.net/components-thumbnails/df1f56da-e2d8-468e-bd34-f7216a3f9202/02319624-2b27-4f4a-ba4b-51fef3f99c4f/4973_1_0.png",
//   "approvedDateTime": "2024-12-02T07:08:27.000+0000",
//   "createdDateTime": "2024-11-08T09:42:30.000+0000",
//   "editedByName": "Muniraj G",
//   "editedDateTime": "2025-02-18T09:48:06.000+0000",
//   "strategicObjectives": [
//       {
//           "strategicObjDamId": "switch_and_stay__c",
//           "strategicObjName": "Switch and Stay"
//       }
//   ],
//   "segments": [
//       {
//           "segmentDamId": "esbvyexpertise_driven_agents_of_chang__c",
//           "segmentName": "ES-BVY-Expertise Driven: Agents of Change"
//       },
//       {
//           "segmentDamId": "esbvyexpertise_driven_caregivers__c",
//           "segmentName": "ES-BVY-Expertise Driven: Caregivers"
//       }
//   ],
//   "indications": [
//       {
//           "indicationDamId": "cll__c",
//           "indicationName": "CLL"
//       },
//       {
//           "indicationDamId": "fl__c",
//           "indicationName": "FL"
//       }
//   ],
//   "claims": [
//       {
//           "claimName": "CL-000973",
//           "claimDamId": "V1X00000001O001",
//           "claimId": "9c134810-dae1-4340-b4be-ce12bf514749",
//           "matchText": "Test Duplicates- Virologically suppressed PWH reported fewer symptoms of feeling anxious/nervous and sad/down/depressed vs.\nABC/3TC/DTG over 48 weeks\"",
//           "topicDamId": "V6G000000001003",
//           "topicName": "Safety",
//           "subtopicName": "Adverse Events",
//           "subtopicDamId": "V6F000000001008",
//           "messageType": "Primary Message",
//           "mustUse": true,
//           "footnotes": "ABC: abacavir,,3TC: lamivudine,,DTG: dolutegravir,,PWH: people with HIV,",
//           "mlrStatus": "Available for Use",
//           "country": "Spain",
//           "matchTextVariants": [],
//           "references": [
//               {
//                   "id": "6953a21f-9cbe-4c1e-bbe9-2a9e9c50f917",
//                   "documentUrl": "https://sb-gilead-poc-global-promomats.veevavault.com/ui/#doc_info/4958/0/1",
//                   "documentName": "Biktarvy 240 Weeks Efficacy (Primary Outcome) Non-Inferior Resistance (n)"
//               }
//           ]
//       },
//       {
//           "claimName": "CL-000872",
//           "claimDamId": "V1X00000001B004",
//           "claimId": "3bdc8bc0-4722-4877-98c1-9de93a881320",
//           "matchText": "Enjoy up to 8 hours of effective pain management with our extended-release capsules, perfect for all-day comfort.",
//           "topicDamId": "V6G000000001009",
//           "topicName": "Disease",
//           "subtopicName": "Diagnosis",
//           "subtopicDamId": "V6F000000001035",
//           "mustUse": true,
//           "footnotes": "Long-term use should be monitored by a healthcare professional. Follow dosing instructions carefully",
//           "mlrStatus": "Available for Use",
//           "country": "Spain",
//           "matchTextVariants": [
//               {
//                   "id": "abd51ffc-70ef-4d92-a78b-c08a948a0580",
//                   "matchText": "Match Text Variation updated"
//               }
//           ],
//           "references": [
//               {
//                   "id": "68069a5b-840c-4865-bb9d-9dc09c953e46",
//                   "documentUrl": "https://sb-gilead-poc-global-promomats.veevavault.com/ui/#doc_info/4721/0/1",
//                   "documentName": "Rx only - Marketed by: Astellas Pharma US, Inc. Northbrook, IL 60062."
//               }
//           ]
//       },
//       {
//           "claimName": "CL-000974",
//           "claimDamId": "V1X00000001L002",
//           "claimId": "45307f69-89f0-4998-bfa5-fb487fa143a1",
//           "matchText": "Test Duplicate References- Virologically suppressed PWH reported fewer symptoms of feeling anxious/nervous and sad/down/depressed vs.\nABC/3TC/DTG over 48 weeks\"",
//           "topicDamId": "V6G000000001003",
//           "topicName": "Safety",
//           "subtopicName": "Adverse Events",
//           "subtopicDamId": "V6F000000001008",
//           "messageType": "Primary Message",
//           "mustUse": true,
//           "footnotes": "ABC: abacavir,,3TC: lamivudine,,DTG: dolutegravir,,PWH: people with HIV,",
//           "mlrStatus": "Available for Use",
//           "country": "Spain",
//           "matchTextVariants": [],
//           "references": [
//               {
//                   "id": "090a2c8c-8a32-4fcb-83ff-6021516ee176",
//                   "documentUrl": "https://sb-gilead-poc-global-promomats.veevavault.com/ui/#doc_info/4958/0/1",
//                   "documentName": "Biktarvy 240 Weeks Efficacy (Primary Outcome) Non-Inferior Resistance (n)"
//               },
//               {
//                   "id": "10f8dd94-a64b-4bb7-84a3-44a34e311219",
//                   "documentUrl": "https://sb-gilead-poc-global-promomats.veevavault.com/ui/#doc_info/5055/0/1",
//                   "documentName": "3 DHHS-recommended initial regimens for most people with HIV"
//               },
//               {
//                   "id": "fbb40053-b210-4039-b223-0b6ed7f15188",
//                   "documentUrl": "https://sb-gilead-poc-global-promomats.veevavault.com/ui/#doc_info/4721/0/1",
//                   "documentName": "Rx only - Marketed by: Astellas Pharma US, Inc. Northbrook, IL 60062."
//               }
//           ]
//       },
//       {
//           "claimName": "CL-000975",
//           "claimDamId": "V1X00000001P001",
//           "claimId": "cfd357aa-0810-4f4a-801f-d0bcdf698012",
//           "matchText": "Test Duplicates - Enjoy up to 8 hours of effective pain management with our extended-release capsules, perfect for all-day comfort.",
//           "topicDamId": "V6G000000001009",
//           "topicName": "Disease",
//           "subtopicName": "Diagnosis",
//           "subtopicDamId": "V6F000000001035",
//           "messageType": "Secondary Message",
//           "mustUse": true,
//           "footnotes": "Long-term use should be monitored by a healthcare professional. Follow dosing instructions carefully",
//           "mlrStatus": "Available for Use",
//           "country": "Spain",
//           "matchTextVariants": [
//               {
//                   "id": "2617dfd5-27b2-4ac6-b037-ee09677078ce",
//                   "matchText": "Match Text Variation updated"
//               }
//           ],
//           "references": [
//               {
//                   "id": "315ffb27-3bd7-402c-b209-75c90e5a67f9",
//                   "documentUrl": "https://sb-gilead-poc-global-promomats.veevavault.com/ui/#doc_info/4958/0/1",
//                   "documentName": "Biktarvy 240 Weeks Efficacy (Primary Outcome) Non-Inferior Resistance (n)"
//               },
//               {
//                   "id": "7dfd7f21-7794-4463-b687-d70c97e1ebe4",
//                   "documentUrl": "https://sb-gilead-poc-global-promomats.veevavault.com/ui/#doc_info/5055/0/1",
//                   "documentName": "3 DHHS-recommended initial regimens for most people with HIV"
//               },
//               {
//                   "id": "d14719a3-5193-42d4-a2a2-ead13617c9c1",
//                   "documentUrl": "https://sb-gilead-poc-global-promomats.veevavault.com/ui/#doc_info/4721/0/1",
//                   "documentName": "Rx only - Marketed by: Astellas Pharma US, Inc. Northbrook, IL 60062."
//               }
//           ]
//       }
//   ],
//   "reusableTexts": [
//       {
//           "reusableTextId": "d7068ac9-8609-4db1-9e65-b8da41e98c03",
//           "reusableTextName": "RT-000182",
//           "reusableTextDamId": "V1X00000001A005",
//           "topicName": "Disease",
//           "topicDamId": "V6G000000001009",
//           "textType": "Tagline",
//           "mustUse": true,
//           "matchText": "MP 2 -Test Expiry1 of related RT",
//           "mlrStatus": "Available for Use",
//           "country": "Spain"
//       },
//       {
//           "reusableTextId": "173a9d0a-01a6-42d6-9b5d-f06d8d40ad3a",
//           "reusableTextName": "RT-000088",
//           "reusableTextDamId": "V1X00000000Y018",
//           "topicName": "Dosing and Administration",
//           "topicDamId": "V6G000000001001",
//           "subtopicName": "Simple Dosing",
//           "subtopicDamId": "V6F000000001001",
//           "textType": "Headline",
//           "mustUse": true,
//           "matchText": "Simple Dosing for You and Your Patients",
//           "mlrStatus": "Available for Use",
//           "country": "Spain"
//       },
//       {
//           "reusableTextId": "ca4f06ce-6ae0-4256-b285-355872744d38",
//           "reusableTextName": "RT-000030",
//           "reusableTextDamId": "V1X00000000H002",
//           "topicName": "Dosing and Administration",
//           "topicDamId": "V6G000000001001",
//           "subtopicName": "Rapid Start/Immediate Start",
//           "subtopicDamId": "V6F000000001014",
//           "textType": "Headline",
//           "mustUse": true,
//           "matchText": "Biktarvy, is a fixed-dose combination antiretroviral medication",
//           "mlrStatus": "Available for Use",
//           "country": "Spain"
//       }
//   ],
//   "components": [
//       {
//           "componentId": "02319624-2b27-4f4a-ba4b-51fef3f99c4f",
//           "componentDocNumber": "COMP-000304",
//           "componentDamId": "4973_1_0",
//           "componentUrl": "https://d2ssk39mx0njby.cloudfront.net/components/df1f56da-e2d8-468e-bd34-f7216a3f9202/02319624-2b27-4f4a-ba4b-51fef3f99c4f/4973_1_0.png",
//           "subType": "Image",
//           "classification": "Photo",
//           "topicDamId": "V6G000000001007",
//           "topicName": "Customer Experience",
//           "subtopicDamId": "V6F000000002003",
//           "subtopicName": "Brand Experience",
//           "componentName": "data_image",
//           "title": "data_image",
//           "mustUse": true,
//           "mlrStatus": "Available for Use",
//           "country": "Spain",
//           "relatedClaims": [],
//           "relatedReusableTexts": []
//       },
//       {
//           "componentId": "36bcde02-3284-4fa9-8091-1cd8c70754db",
//           "componentDocNumber": "COMP-0340",
//           "componentDamId": "5622_1_0",
//           "componentUrl": "https://d2ssk39mx0njby.cloudfront.net/components/7be42b5d-0725-4ae4-8152-67b2aed7e678/36bcde02-3284-4fa9-8091-1cd8c70754db/5622_1_0.png",
//           "subType": "Data Graphic",
//           "classification": "Data Infographic",
//           "topicDamId": "V6G000000001003",
//           "topicName": "Safety",
//           "subtopicDamId": "V6F000000001005",
//           "subtopicName": "Discontinuation",
//           "componentName": "Biktarvy_Illustration_General Asset",
//           "title": "Test Ai file",
//           "mustUse": true,
//           "mlrStatus": "Available for Use",
//           "country": "Spain",
//           "relatedClaims": [
//               {
//                   "id": "5e327ddf-d808-4891-bc7b-7fb63a8eaa04",
//                   "claimName": "CL-000973",
//                   "claimDamId": "V1X00000001O001",
//                   "mlrStatus": "Available for Use",
//                   "matchText": "Test Duplicates- Virologically suppressed PWH reported fewer symptoms of feeling anxious/nervous and sad/down/depressed vs.\nABC/3TC/DTG over 48 weeks\"",
//                   "footnotes": "ABC: abacavir,,3TC: lamivudine,,DTG: dolutegravir,,PWH: people with HIV,",
//                   "references": [
//                       {
//                           "id": "5f0be962-e33f-422e-96a8-6db904f74e90",
//                           "documentName": "Biktarvy 240 Weeks Efficacy (Primary Outcome) Non-Inferior Resistance (n)",
//                           "documentUrl": "https://sb-gilead-poc-global-promomats.veevavault.com/ui/#doc_info/4958/0/1"
//                       }
//                   ]
//               },
//               {
//                   "id": "2183b2f8-3903-438d-a79e-1d8e83904cca",
//                   "claimName": "CL-000974",
//                   "claimDamId": "V1X00000001L002",
//                   "mlrStatus": "Available for Use",
//                   "matchText": "Test Duplicate References- Virologically suppressed PWH reported fewer symptoms of feeling anxious/nervous and sad/down/depressed vs.\nABC/3TC/DTG over 48 weeks\"",
//                   "footnotes": "ABC: abacavir,,3TC: lamivudine,,DTG: dolutegravir,,PWH: people with HIV,",
//                   "references": [
//                       {
//                           "id": "85f6471c-d646-422e-bf1f-32b867aae494",
//                           "documentName": "3 DHHS-recommended initial regimens for most people with HIV",
//                           "documentUrl": "https://sb-gilead-poc-global-promomats.veevavault.com/ui/#doc_info/5055/0/1"
//                       },
//                       {
//                           "id": "a6ec5f72-7924-4fd6-8221-60aab1b3c03e",
//                           "documentName": "Biktarvy 240 Weeks Efficacy (Primary Outcome) Non-Inferior Resistance (n)",
//                           "documentUrl": "https://sb-gilead-poc-global-promomats.veevavault.com/ui/#doc_info/4958/0/1"
//                       },
//                       {
//                           "id": "cee27a78-732a-497c-9c80-46cfc93050a4",
//                           "documentName": "Rx only - Marketed by: Astellas Pharma US, Inc. Northbrook, IL 60062.",
//                           "documentUrl": "https://sb-gilead-poc-global-promomats.veevavault.com/ui/#doc_info/4721/0/1"
//                       }
//                   ]
//               }
//           ],
//           "relatedReusableTexts": [
//               {
//                   "id": "6830ec96-9f60-4ecd-8d96-6cd8577479dc",
//                   "reusableTextName": "RT-000099",
//                   "reusableTextDamId": "V1X00000000Z026",
//                   "mlrStatus": "Expired",
//                   "matchText": "Int-ApigeeRT-099fdf9"
//               }
//           ]
//       },
//       {
//           "componentId": "1ea36349-df6a-4ea9-a926-072956802111",
//           "componentDocNumber": "COMP-0341",
//           "componentDamId": "5623_1_0",
//           "componentUrl": "https://d2ssk39mx0njby.cloudfront.net/components/7be42b5d-0725-4ae4-8152-67b2aed7e678/1ea36349-df6a-4ea9-a926-072956802111/5623_1_0.png",
//           "subType": "Data Graphic",
//           "classification": "Data Table",
//           "topicDamId": "V6G000000001003",
//           "topicName": "Safety",
//           "subtopicDamId": "V6F000000001008",
//           "subtopicName": "Adverse Events",
//           "componentName": "Biktarvy_Data Graphic_Safety_Spain",
//           "title": "Molina JM, et al. 2018.",
//           "mustUse": true,
//           "mlrStatus": "Available for Use",
//           "country": "Spain",
//           "relatedClaims": [
//               {
//                   "id": "022b66e8-d184-478a-bd1c-3c3947125aef",
//                   "claimName": "CL-000973",
//                   "claimDamId": "V1X00000001O001",
//                   "mlrStatus": "Available for Use",
//                   "matchText": "Test Duplicates- Virologically suppressed PWH reported fewer symptoms of feeling anxious/nervous and sad/down/depressed vs.\nABC/3TC/DTG over 48 weeks\"",
//                   "footnotes": "ABC: abacavir,,3TC: lamivudine,,DTG: dolutegravir,,PWH: people with HIV,",
//                   "references": [
//                       {
//                           "id": "f1fc2f18-4433-418d-82c6-0524f0540466",
//                           "documentName": "Biktarvy 240 Weeks Efficacy (Primary Outcome) Non-Inferior Resistance (n)",
//                           "documentUrl": "https://sb-gilead-poc-global-promomats.veevavault.com/ui/#doc_info/4958/0/1"
//                       }
//                   ]
//               },
//               {
//                   "id": "8c5c19d1-7c2d-48f0-91cf-830aa0df973f",
//                   "claimName": "CL-000974",
//                   "claimDamId": "V1X00000001L002",
//                   "mlrStatus": "Available for Use",
//                   "matchText": "Test Duplicate References- Virologically suppressed PWH reported fewer symptoms of feeling anxious/nervous and sad/down/depressed vs.\nABC/3TC/DTG over 48 weeks\"",
//                   "footnotes": "ABC: abacavir,,3TC: lamivudine,,DTG: dolutegravir,,PWH: people with HIV,",
//                   "references": [
//                       {
//                           "id": "267377a9-ba88-46fc-8cfd-7ca143996e16",
//                           "documentName": "Biktarvy 240 Weeks Efficacy (Primary Outcome) Non-Inferior Resistance (n)",
//                           "documentUrl": "https://sb-gilead-poc-global-promomats.veevavault.com/ui/#doc_info/4958/0/1"
//                       },
//                       {
//                           "id": "92ec3cfb-a883-4361-9a23-50c9857b7c75",
//                           "documentName": "3 DHHS-recommended initial regimens for most people with HIV",
//                           "documentUrl": "https://sb-gilead-poc-global-promomats.veevavault.com/ui/#doc_info/5055/0/1"
//                       },
//                       {
//                           "id": "c731697f-1849-4b16-85ae-7726cbfea5f9",
//                           "documentName": "Rx only - Marketed by: Astellas Pharma US, Inc. Northbrook, IL 60062.",
//                           "documentUrl": "https://sb-gilead-poc-global-promomats.veevavault.com/ui/#doc_info/4721/0/1"
//                       }
//                   ]
//               }
//           ],
//           "relatedReusableTexts": [
//               {
//                   "id": "542e6625-5abd-47d4-b50e-666aa5c3ac23",
//                   "reusableTextName": "RT-000093",
//                   "reusableTextDamId": "V1X00000000Y034",
//                   "mlrStatus": "Draft",
//                   "matchText": "Int-ApigeeRT-1aadsdsdsdsds"
//               }
//           ]
//       }
//   ],
//   "businessRules": [
//       {
//           "ruleCondition": "Optional",
//           "targetModules": [
//               {
//                   "targetModuleId": "2b465904-9524-4bf9-8878-110f73780226",
//                   "targetModuleName": "Copy_Module_Of_199",
//                   "targetNextUniqueModuleCode": "BI_Module_053",
//                   "targetModuleDamId": "V3Q00000000Z006",
//                   "targetModuleDamName": "CM-000229",
//                   "targetModuleMlrStatus": null,
//                   "targetModuleComponentUrl": null,
//                   "targetModuleComponentThumbnailUrl": null,
//                   "productName": "Biktarvy",
//                   "moduleDamUrl": "https://sb-gilead-poc-global-promomats.veevavault.com/ui/#object/content_module__v/V3Q00000000Z006",
//                   "cmsdDocUrl": null
//               }
//           ]
//       },
//       {
//           "ruleCondition": "CannotExistWith",
//           "targetModules": [
//               {
//                   "targetModuleId": "7a01c078-bcc0-427f-98d2-42b37b75035f",
//                   "targetModuleName": "test-venkat",
//                   "targetNextUniqueModuleCode": "BI_Module_058",
//                   "targetModuleDamId": "V3Q000000012007",
//                   "targetModuleDamName": "CM-000281",
//                   "targetModuleMlrStatus": null,
//                   "targetModuleComponentUrl": null,
//                   "targetModuleComponentThumbnailUrl": null,
//                   "productName": "Biktarvy",
//                   "moduleDamUrl": "https://sb-gilead-poc-global-promomats.veevavault.com/ui/#object/content_module__v/V3Q000000012007",
//                   "cmsdDocUrl": "https://sb-gilead-poc-global-promomats.veevavault.com/ui/#doc_info/5313"
//               }
//           ]
//       },
//       {
//           "ruleCondition": "MustExistWith",
//           "targetModules": [
//               {
//                   "targetModuleId": "7f90d357-4317-4014-bae3-7ef229634920",
//                   "targetModuleName": "Dummy",
//                   "targetNextUniqueModuleCode": "BI_Module_059",
//                   "targetModuleDamId": "V3Q000000017001",
//                   "targetModuleDamName": "CM-000304",
//                   "targetModuleMlrStatus": null,
//                   "targetModuleComponentUrl": null,
//                   "targetModuleComponentThumbnailUrl": null,
//                   "productName": "Biktarvy",
//                   "moduleDamUrl": "https://sb-gilead-poc-global-promomats.veevavault.com/ui/#object/content_module__v/V3Q000000017001",
//                   "cmsdDocUrl": "https://sb-gilead-poc-global-promomats.veevavault.com/ui/#doc_info/5802"
//               }
//           ]
//       }
//   ],
//   "cmsdDocId": "5803",
//   "cmsdMajorV": "0",
//   "cmsdMinorV": "3",
//   "cmsdDocUrl": "https://sb-gilead-poc-global-promomats.veevavault.com/ui/#doc_info/5803",
//   "logos": [
//       "https://d2ssk39mx0njby.cloudfront.net/LOGO/modulePreviewArrow.svg",
//       "https://d2ssk39mx0njby.cloudfront.net/LOGO/mustUseGreenDot.svg",
//       "https://d2ssk39mx0njby.cloudfront.net/LOGO/mustUseRedDot.svg",
//       "https://d2ssk39mx0njby.cloudfront.net/LOGO/final-status.svg",
//       "https://d2ssk39mx0njby.cloudfront.net/LOGO/statusDraft.svg",
//       "https://d2ssk39mx0njby.cloudfront.net/LOGO/statusApproved.svg",
//       "https://d2ssk39mx0njby.cloudfront.net/LOGO/Intermediate.svg",
//       "https://d2ssk39mx0njby.cloudfront.net/LOGO/infoIcon.svg"
//   ],
//   "sourceModuleDamName": null,
//   "sourceModuleMlrStatus": null,
//   "sourceModuleDamUrl": null,
//   "moduleDraftElementIncluded": null,
//   "buisnessRuleSaved": true
// }
const ModuleView = ({
  modulePreviewData,
  modulePreviewOpen,//state
  setModulePreviewOpen,// state
}) => {
  const getMLRstatusIcon=(mlr)=>{
    if(mlr==="Available for Use"){
      return checkMark;
    }
    else if(mlr==="Expired"){
      return checkMarkExpired;
    }
    else if(mlr==="Draft"){
      return NotApprovedImage;
    }
  }
  function truncateText(text) {
    if (text.length > 12) {
      return text.substring(0, 12) + "...";
    }
    return text;
  }
  
  return (
    <>
      <Dialog
        open={modulePreviewOpen}
        className="module-view-modal "
        aria-labelledby="form-dialog-title"
        overlaystyle={{ backgroundColor: "transparent" }}
      >
        <div className="module-view-modal-wrapper">
          <div className="module-header-container">
            <div style={{ marginLeft: "0px" }} className="module-name-text">
              Preview : Content Module Submission Document (CMSD)
            </div>
            <div className="module-view-header">
              <div className="module-name-container">
                <div className="module-light-text"> Module Name: </div>
                <Tooltip title={modulePreviewData?.moduleName}>
                  <div className="module-name-text">
                    {truncateText(modulePreviewData?.moduleName)}
                  </div>
                </Tooltip>
              </div>
              <div className="module-name-container">
                <div className="module-light-text"> Module Id: </div>
                <div className="module-name-text">
                  {modulePreviewData?.moduleDamName}
                </div>
              </div>

              <div className="module-name-container">
                <div className="module-light-text"> MLR Status: </div>
                <img
                  src={getMLRstatusIcon(modulePreviewData?.mlrStatus)}
                  style={{ marginLeft: "4px" }}
                  alt="CheckMark"
                  className="img-fluid greenCheckmark "
                />
                <div className="module-name-text">
                  {modulePreviewData?.mlrStatus}
                </div>
              </div>
            </div>
          </div>
          <div className="module-divider-line"></div>
        </div>
        <ModulePreviewData
          modulePreviewData={modulePreviewData}
          openedFromModal={true}
        />
        <DialogActions className="module-view-footer modalActions templateBtn">
          <div className="clone-text">
            {/* To clone this module <p className="click-here-link">click here</p> */}
          </div>
          <Button
            onClick={() => setModulePreviewOpen(false)}
            type="submit"
            className="temp-btn"
            // autoFocus
          >
            {"CLOSE"}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
export default ModuleView;
